import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Pane, SplitPane } from '@sierralabs/core-ui';
import { EntityProvider } from '../EntityContext';
import EntityEditPanel from './EntityEditPanel';
import EntityListPanel from './EntityListPanel';
const StyledDiv = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  background: #fff;
  .editor-container {
    flex: 1;
  }
  .navigation-pane {
    min-width: 240px;
  }
  .entity-pane {
    min-width: 500px;
  }
  .flex {
    flex: 1;
  }
`;
export const EntityEditor = props => {
    const { entityId } = useParams();
    return (React.createElement(EntityProvider, Object.assign({}, props),
        React.createElement(StyledDiv, { className: 'entity-editor' },
            React.createElement(SplitPane, { className: 'editor-container' },
                React.createElement(SplitPane, { width: 240, primary: 'next', className: 'navigation-pane' },
                    React.createElement(SplitPane, { direction: 'vertical', className: 'entity-list-pane' },
                        React.createElement(EntityListPanel, null))),
                React.createElement(Pane, { className: 'entity-pane' },
                    React.createElement(EntityEditPanel, null))))));
};
export default EntityEditor;
//# sourceMappingURL=EntityEditor.js.map